import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from "react";
import { Col, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { proratas } from "../../../../src/app/base/proratas";
import { API_PAYMENT_CONFIG } from '../../../app/base/constant';
import { API_ROUTE_CONTROLLER } from "../../../app/base/routes";
import { ApiServices } from '../../../app/base/service/apiService';
import { validator } from '../../../lib/validator';
import { NumberService } from '../../../service/addnumber';
import { PLAN_PURPOSE_INFO } from "../../../service/constant";
import { paymentserviceNumbersStep1Result } from '../../../store/login';
import { setPaymentFrom } from '../../../store/paymentservice';
import Stripe from "../../../stripe_payment";
import Loaders from '../../loader';
import masterlogo from "../../../styles/images/masterlogo.svg";
import ToastError from "../../toastError";
import styles from "../../AddOns/scss/paymentconfirm.module.scss";

const AddonPayment = (props) => {

  const numberSer = new NumberService();
  const login = useSelector((state: any) => state.login.login);
  const loginCred = useSelector((state: any) => state.login.loginCred);
  console.log("login",login,loginCred)
  const product = useSelector((state: any) => state.constant.products);
  const _constant = useSelector((state: any) => state.constant);
  console.log("_constant_constant", _constant);
  const getSavedCardPaymentData = useSelector((state: any) => state.payment.SavedCardPaymentData);
  const paymentservice = useSelector((state: any) => state.payment);
  const user = useSelector((state: any) => state.user);
  console.log("user.getDataEnterFromAddCardUpdate", user.getDataEnterFromAddCardUpdate)
  const ob = new proratas;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sms_whatsapp = useSelector((state: any) => state.constant.sms_whatsapp);
  console.log("sms_whatssms_whats", sms_whatsapp);
  const sms_whatsapp_no = useSelector((state: any) => state.constant.sms_whatsapp_number);
  console.log("sms_whatsapp_nosms_whatsapp_no", sms_whatsapp_no);
  const purchaseNewNo = useSelector((state: any) => state.constant.purchaseNewNo);
  console.log("purchaseNewNopurchaseNewNo", purchaseNewNo);

  const [getCvv, setCvv] = useState(0);
  const [getErrorMessage, setErrorMessage] = useState('');
  const [getCountryListData, setCountryListData] = useState([]);
  const [getCompanyAddress, setCompanyAddress] = useState<any>([]);
  console.log("getCompanyAddress", getCompanyAddress)
  const [getErrorMessage1, setErrorMessage1] = useState('');
  const [getDatas, setDatas] = useState();
  const [savedCardList, setSavedCardList] = useState([]);
  const [getSavedPrimaryCard, setSavedPrimaryCard] = useState([]);
  console.log("getSavedPrimaryCard", getSavedPrimaryCard)
  const [getPrimaryCard, setPrimaryCard] = useState<any>('');
  const [getCurrentDate, setCurrentDate] = useState('');
  const [getTax, setTax] = useState(20);
  const [getTotalAmount, setTotalAmount] = useState(0);
  const [getTotalTaxAmount, setTotalTaxAmount] = useState(0);
  const [getTotalAmountWithTax, setTotalAmountWithTax] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(true);
  console.log("isChecked1",isChecked1)
  const [getLoader, setLoader] = useState(false);
  const [getDefualtCard, setDefualtCard] = useState(false);
  const [getSelectedDefualtCard, setSelectedDefualtCard] = useState(false);
  const [cardStatus, setCardStatus] = useState('');
    const [paymentModal,setPaymentModal] =useState(false)

  const [getProRata, setProRata] = useState(0);
  const [getPCprice, setPCprice] = useState(0);
  const [getalreadyPurchasedCount, setalreadyPurchasedCount] = useState(0);
  const [getCurrentPlanName, setCurrentPlanName] = useState('');
  const [getPlanMaxUserCount, setPlanMaxUserCount] = useState(0);
  const [getBeforeAdjustmentTotalAmount, setBeforeAdjustmentTotalAmount] = useState(0);

  const [total_pro_user_proRata, setProUserRata] = useState(0);
  const [total_standard_user_prorata, setStandardUserRata] = useState(0);
  const [total_basic_user_prorata, setBasicUserRata] = useState(0);
  const [getcard, setCardType] = useState('');
  const [formErrors, setFormErrors] = useState<any>({});
  const [getAdjustmentAmount, setAdjustmentAmount] = useState(0);
  const [addonType, setAddonType] = useState(localStorage.getItem("addonType"))

  let intialValues = {
    user_type: "",
    first_name: login.First_name,
    last_name: login.Last_name,
    ur_customer_id: login.usr_id,
    mobileno: login.contactno,
    emp_id: login.employee_id,
    position: '',
    department: '',
    phone_code: login.contactno,
    phone_number: login.contactno,
    role: login.role_id,
    status: login.status,
    extension: login.extension,
    streetname: '',
    city: '',
    postcode: '',
    country: API_PAYMENT_CONFIG.payment_country,
    email: loginCred.username,
  };

  const [userFormValues, setFormValues] = useState<any>(intialValues);
  const addonSelectedId = localStorage.getItem("addonSelectedId");
  console.log("addonSelectedIdaddonSelectedId", addonSelectedId);
  const addonSelectedIdNumber = addonSelectedId ? parseInt(addonSelectedId, 10) : null;
  console.log("addonSelectedIdNumber", addonSelectedIdNumber);

  let street_name: any, postcode: any, city: any, country: any, card_number: any, cvv: any, cc_type: any, expdate: any, mobileno: any, customer_id: any, ch_name_p: any, contact_email: any, paymentfrom: any, productcode: any, address1: any, address2: any, address3: any, pin_code: any = "";
  if (typeof window !== "undefined") {
    productcode = 'SC-AN';
    customer_id = loginCred.customer_id;
    card_number = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.card.replace(/\s+/g, '') : "";
    cvv = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.securityCode : "";
    expdate = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.expiry : "";
    address1 = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.address1 : "";
    address2 = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.address2 : "";
    address3 = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.address3 : "";
    pin_code = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.pin_code : "";
    ch_name_p = paymentservice.paymentCardDetails ? paymentservice.paymentCardDetails.cardHodler : "";
    mobileno = "";
  }

  
  const optionsMonth = [
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' }
  ]

  const optionsYear = [
    { value: '2023', label: '2023' },
    { value: '2024', label: '2024' },
    { value: '2025', label: '2025' }
  ]

  const [modalShow, setmodalShow] = useState(false);
  const [modalShownew, setmodalShownew] = useState(false);


  const handleShow = () => setmodalShow(true);
  const handleClosenew = () => setmodalShownew(false);
  const handleShownew = () => setmodalShownew(true);

  const getAddonsCartList = async () => {
    let cart: any = _constant.carts.map((a: any) => ({ addon_id: a.addonid, addon_name: a.addon_name, addon_price: a.addon_price, addon_qty: a.quantity, msisdn_info: "", uu_id: "", total_charge: a.totalAmount, total_chargewithout_tax: 0, tax_per: 0, tax_fee: 0 }));

  };

  const getSavedCardList = () => {
    try {
      let data = {
        "company_id": login.company_id, //6654, 
      };
      ApiServices.post(data, API_ROUTE_CONTROLLER.Urmyaccountgetcccardinfo).then(async (resp: any) => {
        if (resp.data.message == 'success') {
          const primaryCard = resp.data.finalresponse.filter((item: any) => { if (item.is_card_default_desc == 'Primary card') { return item; } });
          setSavedCardList(resp.data.finalresponse);
          setSavedPrimaryCard(primaryCard);
          setPrimaryCard(primaryCard[0])
        }
      })
    } catch (error) {
    } finally {
    }

  }

  const handleSelectCard = (card: any, index: any) => {
    setDefualtCard(true);
    setSelectedDefualtCard(index);
    const myArray: any = [card];
    setSavedPrimaryCard(myArray);
    setPrimaryCard(card);
    setmodalShow(false);
  }

  const selectCard = () => {
    setDefualtCard(true);
    setmodalShow(false);
  }

  const handleClose = () => {
    setmodalShow(false);
  }


  const getCountryList = async () => {
    try {
      let _url = API_ROUTE_CONTROLLER.Urmyaccgetcountrylistinfo;
      await ApiServices.get(_url).then(res => {

        if (res) {
          setCountryListData(res.data.finalresponse);
        }
      });
    } catch (error) {
    } finally {
    }
  }

  const getCompanyAddressApi = async () => {
    try {
      const _url = API_ROUTE_CONTROLLER.Urmyaccountgetcompanyaddress + "/" + login.company_id
      await ApiServices.get(_url).then(res => {

        if (res) {
          setCompanyAddress(res.data.finalresponse);
        }
      });
    } catch (error) {
    } finally {
    }
  }

  const currentYear = new Date().getFullYear();
  const futureYear = currentYear + 12;

  const dateOptions = Array.from({ length: 12 }, (_, index) => index + 1);
  let values = {
    card_name: "",
    card_number: "",
    cvv: "",
    exp_date: "",
    address: "",
    country: "",
    city: "",
    exp_year: "",
    postcode: "",
  }
  const [cardNumber, setCardNumber] = useState("")
  const [getValue, setValue] = useState(values);
  const [ip, setIP] = useState<any>('');

  const getUserData = async () => {
    const res = await axios.get('https://getip.worktual.co.uk/')
    console.log("reserer4wrr", res.data.clientIPv6)
    setIP(res.data.clientIPv6)
    localStorage.setItem("userIp", res.data.clientIPv6);
  }

  const validate = (values: any) => {
    const errors: any = {};
    var ob = new validator;
    errors.card_name = ob.set(values.card_name)
      .required("Please enter the name on card")
      .msg;
    errors.card_number = ob.set(values.card_number)
      .required("Please enter card number")
      .msg;
    errors.cvv = ob.set(values.cvv)
      .numeric("Please enter the numeric")
      .required("Please enter cvv")
      .msg;
    errors.exp_date = ob.set(values.exp_date)
      .required("Please select date")
      .msg;
    errors.exp_year = ob.set(values.exp_year)
      .required("Please select year")
      .msg;
    if (!isChecked1) {
      errors.address = ob.set(values.address)
        .required("Please enter the address")
        .msg;
      errors.country = ob.set(values.country)
        .required("Please enter the country")
        .msg;
      errors.city = ob.set(values.city)
        .required("Please enter the city")
        .msg;
      errors.postcode = ob.set(values.postcode)
        .required("Please enter the postcode")
        .msg;
    }
    return errors;
  };

  const formatCardNumber = (value: any) => {
    const regex = /[^0-9]/g;
    const cleanedValue = value.replace(regex, '');
    const formattedValue = cleanedValue.replace(/(.{4})/g, '$1 ');
    return formattedValue.trim();
  }


  const handPaymentSummit =()=>{
    if (isChecked == false) {
        setErrorMessage1('Please confirm payment receipt');
        setLoader(false)
        return
      } 
      setPaymentModal(true);
      setErrorMessage1("");
  }

  const freeplanSubmit=()=>{
    if (isChecked == false) {
      //  //console.log('2');
      setErrorMessage1('Please confirm payment receipt');
    }
    else {
      setErrorMessage1('');
      navigate('/addonsuccess')
    }
  }
  const onPaymentResult=(obj)=>{
            console.log("payment func",obj,obj.paymentIntent)
            setPaymentModal(false);
            setLoader(true);
      
         if (obj?.status == "failed") {
           setCardStatus("Payment Failed")
           setTimeout(() => {
             setCardStatus('')
           }, 3000);
           setLoader(false);
           return;
         }else if (obj?.status == "succeeded"){
            dispatch(paymentserviceNumbersStep1Result({ Ref_Id: obj?.paymentIntent?.id }));
            dispatch(setPaymentFrom("AddonPayment"));
            navigate('/addonsuccess');
            setLoader(false); 
      }
  }
  const addonPaymentSuccessSubmit = () => {

    const addonJson = JSON.stringify(getDatas);
    if (getTotalAmountWithTax > 0 && isChecked == true && getCvv > 0) {
      // let data = {
      //   "company_id": login.company_id, //7284, 
      //   "plan_id": product[0].plan_id,
      //   "jsonAddonInfo": addonJson,
      //   "total_charge": getTotalAmountWithTax,
      //   "total_chargewithout_tax": getTotalAmount,
      //   "Pay_Reference": "12345689",
      //   "tax_per": getTax,
      //   "tax_fee": getTotalTaxAmount,
      //   "last4digitcc": getPrimaryCard.cc_no ? getPrimaryCard.cc_no : "0077"
      // };
      // ApiServices.post(data, API_ROUTE_CONTROLLER.bulk_addon_purchase).then(async (resp: any) => {
      //   //console.log("Urgetaddonfeaturelist2", resp.data);
      //   if (resp.data.message == 'success') {
      //     setLoader(false);
      //     navigate('/addonsuccess');
      //   }
      // })
      navigate('/addonsuccess');
    }
    else {
      if (getCvv > 0) {
        setErrorMessage('Please enter card CVV number');
      }
      if (isChecked == false) {
        setErrorMessage('Please confirm payment receipt');
      }
      setErrorMessage('');

    }
  }

  const getBillServicePlan = async () => {
    try {
      const _url = API_ROUTE_CONTROLLER.UrgetBillServicePlan;
      const _body = {
        "company_id": login.company_id,
      };
      const res = await ApiServices.post(_body, _url);
      if (res.data.message !== 'No data found') {
        setPCprice(res.data.result[0].pc_price);
        const _date = res.data.result[0].bill_cycle.split("-");
        let sum_prorata = ob.prorata(_date[0].trim(), _date[1].trim(), 1, parseFloat(res.data.result[0].pc_price));
        const get_pro_price = sum_prorata.toFixed(2);
        setProRata(sum_prorata);
        return res.data.result[0];
      }
    } catch (error) {
    } finally {
    }
  };

  const getplandetails = async () => {
    try {
      let _url = API_ROUTE_CONTROLLER.getTirePlanPurposeInfo;
      let _body = {
        "purpose_id": PLAN_PURPOSE_INFO.PURPOSE_ID,
        "product_id": 1
      };
      await ApiServices.post(_body, _url).then((res) => {

      }
      );
    } catch (error) {
    } finally {
    }
  }

  // get purchased user count
  const getUserType = async () => {
    try {
      let _url2 = API_ROUTE_CONTROLLER.Urdevicegetusertype;
      let _body2 = {
        "domain_id": login.domain_id,
      };
      const userType: any = await ApiServices.post(_body2, _url2)
      const totalTotCount = userType.data.finalresponse.reduce((total, item) => {
        return total + Number(item.tot_count);
      }, 0);
      setalreadyPurchasedCount(totalTotCount)
    } catch (error) {
    } finally {
    }
  }

  const handleCCvChange = (ccv: any) => {
    setCvv(ccv.target.value);
    ////console.log('ccv', ccv.target.value);
  }

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setErrorMessage1("");
  };

  const handleCancelPayment = () => {
    navigate("/purchase");
  }

  useEffect(() => {
    try {
      const init2 = async () => {
        await getplandetails();
        await getUserType();
        await getCountryList();
        await getCompanyAddressApi()

      };
      init2();
  
      setCurrentPlanName(product[0].pln_name);
      if (product[0].pln_name == 'Free') {
        setCurrentPlanName(product[0].pln_name);
        setPlanMaxUserCount(5);
      }
      else if (product[0].pln_name == 'Growth') {
        setCurrentPlanName(product[0].pln_name);
        setPlanMaxUserCount(99);
      }
      else {
        setCurrentPlanName(product[0].pln_name);
        setPlanMaxUserCount(100000000);
      }
    } catch (error) {
      console.log("API error");
    } finally {
      // setIsLoading(false);
    }

    getUserData();
    const currentDate = moment().format('MM/DD/YYYY');
    setCurrentDate(currentDate);
    const init = async () => {
      let retString: string | null = localStorage.getItem("Addons");
      let localDatas = retString !== null && retString !== '' ? JSON.parse(retString) : _constant.addons;
      getSavedCardList();
      getAddonsCartList();

      const userAddonCount = localDatas.filter(item => {
        if (item.addon_name == 'Additional user(s)' || item.addon_name == 'User licence (Standard)' || item.addon_name == 'User licence (Basic)' || item.addon_name == 'Additional seat(s)') {
          return item.quantity;
        }
      })
      let userCount = userAddonCount && userAddonCount.length > 0 ? parseInt(userAddonCount[0].quantity) : 0;


      let getalreadyPurchasedCount1: string | null = localStorage.getItem("alreadyPurchasedCount");
      const getalreadyPurchasedCount = getalreadyPurchasedCount1 ? parseInt(getalreadyPurchasedCount1) : 0;
      let getPlanMaxUserCount1: string | null = localStorage.getItem('PlanMaxUserCount');
      const getPlanMaxUserCount = getPlanMaxUserCount1 ? parseInt(getPlanMaxUserCount1) : 0;

      let pro_user_count1: string | null = localStorage.getItem("pro_user_count");
      const pro_user_count = pro_user_count1 ? parseInt(pro_user_count1) : 0;
      let standard_user_count1: string | null = localStorage.getItem("standard_user_count");
      const standard_user_count = standard_user_count1 ? parseInt(standard_user_count1) : 0;
      let basic_user_count1: string | null = localStorage.getItem("basic_user_count");
      const basic_user_count = basic_user_count1 ? parseInt(basic_user_count1) : 0;

      let newAddUsersCount1: string | null = localStorage.getItem("newAddUsersCount");
      const newAddUsersCount = newAddUsersCount1 ? parseInt(newAddUsersCount1) : 0;
      const totalPurchasedUser = getalreadyPurchasedCount + newAddUsersCount;


      const _billing_details = await getBillServicePlan();
      const _date = _billing_details.bill_cycle.split("-");
     let total_pro_user_proRata = ob.prorataForAddon(_date[0].trim(), _date[1].trim(), userCount, parseFloat(_billing_details.pc_price));


      let total_standard_user_prorata = ob.prorataForAddon(_date[0].trim(), _date[1].trim(), standard_user_count, parseFloat(_billing_details.pc_price));
      let total_basic_user_prorata = ob.prorataForAddon(_date[0].trim(), _date[1].trim(), basic_user_count, parseFloat(_billing_details.pc_price));
      let total_sum_prorata = ob.prorataForAddon(_date[0].trim(), _date[1].trim(), totalPurchasedUser, parseFloat(_billing_details.pc_price));
      const get_pro_price = total_sum_prorata.toFixed(2);
      setProUserRata(total_pro_user_proRata);
      setStandardUserRata(total_standard_user_prorata);
      setBasicUserRata(total_basic_user_prorata);
      setProRata(total_sum_prorata);


      // addon Total Amount
      let sum = 0;
      _constant.carts.forEach((item: any) => {
        sum += item.totalAmount;
      });

      let sumAmt = 0;
      _constant.carts.forEach((item: any) => {
        if (item.addon_name == 'Additional user(s)' || item.addon_name == 'User licence (Standard)' || item.addon_name == 'User licence (Basic)' || item.addon_name == 'Additional seat(s)') {
          // sumAmt += item.totalAmount;
        }
        else {
          ////console.log('addon_name : ', item.addon_name);
          sumAmt += item.totalAmount;
        }
      });

      let usrsumAmt = 0;
      _constant.carts.forEach((item: any) => {
        if (item.addon_name == 'Additional user(s)' || item.addon_name == 'Additional seat(s)' || item.addon_name == 'User licence (Standard)' || item.addon_name == 'User licence (Basic)') {
          usrsumAmt += item.totalAmount;
        }
        else {
        }
      });
let totalAmountWithoutTax: any = (sumAmt + total_pro_user_proRata).toFixed(2);
      const AdjustmentAmount = usrsumAmt - total_pro_user_proRata;
      setAdjustmentAmount(AdjustmentAmount);
      setBeforeAdjustmentTotalAmount(sum);

      if (addonType == "purchaseNewNumber") {
        totalAmountWithoutTax = parseFloat(totalAmountWithoutTax) + 2;
      } else {
        totalAmountWithoutTax = totalAmountWithoutTax
      }
      console.log("totalAmountWithoutTax", totalAmountWithoutTax)
      setTotalAmount(totalAmountWithoutTax)
      let totalAmountWithoutTax1: string | null = totalAmountWithoutTax;
      const totalAmountWithoutTax2 = totalAmountWithoutTax1 ? parseInt(totalAmountWithoutTax1) : 0;
      const TotalTaxAmount = (totalAmountWithoutTax2 * getTax / 100);
      setTotalTaxAmount(TotalTaxAmount);

      setTotalAmountWithTax(totalAmountWithoutTax2 + totalAmountWithoutTax2 * getTax / 100);
      setDatas(localDatas);


    };
    init();


  }, [])

  return (
    <>
 { !(product[0]?.plan_id == 160 && product[0].Is_free_trail == 1) ? 
    <>
    {cardStatus ?	<ToastError errorMsg={cardStatus}></ToastError> : <> </> }
      <Row className="breadcrumbarea">
        <Col sm={12}>
          <h4>Purchase Cart</h4>
          <p>Purchase Add-ons, Licenses and Numbers based on your preference</p>
        </Col>
      </Row>

      <div>
        <div className={styles.purchasecartinfo}>
          <div className={styles.addonlists}>

            <div className="nopadding nopaddingleft">
              <div className={`${styles.cartdetails} ${styles.cartdetailsleft}`}>
                <h5>Payment Details</h5>
                <div className={`${styles.paymenttable}`}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Qty</th>
                          <th>Unit Price</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          _constant.carts && _constant.carts.map((item: any, index: any) => (
                            <tr>
                              <td>{item.addon_name}</td>
                              <td>{item.quantity}</td>
                              <td>&pound; {item.addon_price}</td>
                              <td>&pound; {item.totalAmount}</td>
                            </tr>
                          ))
                        }
                        
                        {addonType == "purchaseNewNumber" ?
                          <tr>
                            <td>SMS Number</td>
                            <td>1</td>
                            <td>&pound; <>2 </></td>
                            <td>&pound; 2</td>
                          </tr> : ""
                        }

                      

                        <tr>
                          <td></td>
                          <td></td>
                          <td><h6>Subtotal (Excl.VAT) </h6></td>
                          { } <td>&pound; {getTotalAmount}</td>
                        </tr>

                        <tr>
                          <td></td>
                          <td></td>
                          <td><h6>Value Added Tax - 20%</h6></td>
                          <td>&pound; {getTotalTaxAmount}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td><h5>Total (Incl.VAT)</h5></td>
                          <td><h6>&pound; {getTotalAmountWithTax}</h6></td>
                        </tr>
                        
                      </tbody>
                    </table>
                    <label className="checkbox-button checkbox-button1 authoriselabel acknowledgement">
                      <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" checked={isChecked} onChange={handleCheckboxChange} />
                      <span className="checkbox-button__control"></span>
                      <span className="checkbox-button__label">I authorise to be charged the amount of £ {getTotalAmountWithTax}. I acknowledge that I have read this information and understand the itemised charges listed above. I further authorise the monthly recurring charges of £ {getTotalAmount} begining on {getCurrentDate} and continuing until cancelled.</span>
                    </label>
                    <p className="securecheckerror securecheckerrorpayment">{getErrorMessage1 && getErrorMessage1 ? getErrorMessage1 : ""}</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
       


      </div>

      <div className={styles.bottomarea}>
        <Col sm={12} className={styles.bottomareainner}>
          <button className="cancelbtn" onClick={handleCancelPayment} >Cancel</button>
          <button onClick={handPaymentSummit}>Confirm Payment</button>
          

        </Col>
      </div>

      <Modal show={modalShow} onHide={handleClose} className="modaldefaults" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Select Card</Modal.Title>
        </Modal.Header>
        <Modal.Body className='modalbigspace'>
          <div className="forcardsin" >
            {savedCardList && savedCardList.map((card: any, index: any) => (
              <div className={`${styles.addonsmain} ${styles.modelcard} ${getSelectedDefualtCard == index ? 'focused' : ''}`} onClick={() => handleSelectCard(card, index)}>
                <div className={styles.lefts}>
                  <img src={masterlogo} />
                  <div className={styles.addondetails}>
                    <h5>xxxx xxxx xxxx {card.cc_no}</h5>
                    <p>{card.card_type} {card.is_card_default_desc}</p>
                  </div>
                </div>
              </div>
            ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p onClick={handleShownew}><span className="cardplus">+</span>Add Card</p>
          <button onClick={handleClose} className="cancelbtn">Cancel</button>
        </Modal.Footer>
      </Modal>

       <Modal show={paymentModal} maskClosable={false}  onHide ={()=>setPaymentModal(false)}className="modaldefaults paymentmodel modalminheight" backdrop="static">
                <Modal.Header closeButton>
                    {/* <Modal.Title></Modal.Title> */}
                </Modal.Header>
                <Modal.Body className='modalbigspace'>
                    <Stripe amount = {getTotalAmountWithTax}  onPaymentResult ={onPaymentResult}/>
                </Modal.Body>
               
            </Modal>

     
      {getLoader == true ? <Loaders></Loaders> : ""}
    </> :
    <>
          <Row className="breadcrumbarea">
        <Col sm={12}>
          <h4>Purchase Cart</h4>
          <p>Purchase Add-ons, Licenses and Numbers based on your preference</p>
        </Col>
      </Row>
      <div>
        <div className={styles.purchasecartinfo}>
          <Row  sm={12} className={styles.addonlists}>
            <Col sm={12} className="nopadding nopaddingleft" style={{width:"100%"}}>
              <div className={`${styles.cartdetails} ${styles.cartdetailsleft}`} style={{minHeight:"280px"}}>
                <h5>Payment Details</h5>
                <div className={`${styles.paymenttablefreetrial}`}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          _constant.carts && _constant.carts.map((item: any, index: any) => (
                            <tr>
                              <td>{item.addon_name} ({item.addon_desc})</td>
                              <td>{item.quantity}</td>
                            </tr>
                          ))
                        }
                        {addonType == "purchaseNewNumber" ?
                          <tr>
                            <td>SMS Number</td>
                            <td>1</td>
                          </tr> : ""
                        }
                      </tbody>
                    </table>
                    <label className="checkbox-button checkbox-button1 authoriselabel acknowledgement">
                      <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" checked={isChecked} onChange={handleCheckboxChange} />
                      <span className="checkbox-button__control"></span>
                      <span className="checkbox-button__label">I authorise to be charged the amount of £ {getTotalAmountWithTax}. I acknowledge that I have read this information and understand the itemised charges listed above. I further authorise the monthly recurring charges of £ {getTotalAmount} begining on {getCurrentDate} and continuing until cancelled.</span>
                    </label>
                    <p className="securecheckerror securecheckerrorpayment">{getErrorMessage1 && getErrorMessage1 ? getErrorMessage1 : ""}</p>
                </div>
              </div>
            </Col>  
          </Row>
        </div>
        <div className={styles.bottomarea}>
        <Col sm={12} className={styles.bottomareainner}>
          <button className="cancelbtn" onClick={handleCancelPayment} >Cancel</button>
          <button onClick={freeplanSubmit}>Confirm Payment</button>
        </Col>
      </div>
      </div>
    </>}
    </>
  );
};
export default AddonPayment;